(function() { window.GUID_e675f295_7835_4559_8ac6_7cbfe57428de = { getGuid: function() { return "e675f295-7835-4559-8ac6-7cbfe57428de"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PremiumLockedOverlayLockIconVariant;
        (function (PremiumLockedOverlayLockIconVariant) {
            PremiumLockedOverlayLockIconVariant[PremiumLockedOverlayLockIconVariant["Small_Centered"] = 0] = "Small_Centered";
            PremiumLockedOverlayLockIconVariant[PremiumLockedOverlayLockIconVariant["Small_TopRight"] = 1] = "Small_TopRight";
            PremiumLockedOverlayLockIconVariant[PremiumLockedOverlayLockIconVariant["Small_TopLeft"] = 2] = "Small_TopLeft";
            PremiumLockedOverlayLockIconVariant[PremiumLockedOverlayLockIconVariant["Medium_Centered"] = 3] = "Medium_Centered";
            PremiumLockedOverlayLockIconVariant[PremiumLockedOverlayLockIconVariant["Large_Centered"] = 4] = "Large_Centered";
            PremiumLockedOverlayLockIconVariant[PremiumLockedOverlayLockIconVariant["None"] = 5] = "None";
        })(PremiumLockedOverlayLockIconVariant = Enumeration.PremiumLockedOverlayLockIconVariant || (Enumeration.PremiumLockedOverlayLockIconVariant = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PremiumLockedOverlayLockIconVariant.pre.js.map
